import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutQuoteCustomerQuickInfo extends Layout {
    citystate1: CityState;
    labelBridgeIdDescription: Textbox;
    labelCustomerWebsite: Textbox;
    panel1: Panel;
    sourceQuoteCustomer: DataSource;
    textboxBridgeCustomer: Textbox;
    textboxEdiCustomerCarrier: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
    textboxPartnerValue: Textbox;
    textboxSalespersonName: Textbox;
    textboxScac: Textbox;
}
